/* eslint-disable no-underscore-dangle */
/* eslint-disable no-console */
import { Analytics } from '../analytics';
import { AnalyticsAdapter } from '../types';

class DevelopmentAnalytics implements AnalyticsAdapter {
  private _isInitialized = false;

  initialize() {
    this._isInitialized = true;
  }

  isInitialized() {
    return this._isInitialized;
  }

  track(event: string, options?: Record<string, string>) {
    console.log('[ANALYTICS] track');
    console.table({ event, options });
  }
}

export const developmentAnalytics = new Analytics(new DevelopmentAnalytics());
